(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cnct-drop-urgency"] && !Shopify.designMode) return;
  try {
    (function () {
  function pad(n) { n = parseInt(n, 10); return n < 10 ? '0' + n : '' + n; }

  function parseEnd(raw, tz) {
    raw = String(raw || '').trim();
    var y, mo, d, h, mi;
    var m = raw.match(/^(\d{4})[-\/.](\d{1,2})[-\/.](\d{1,2})(?:[ T]+(\d{1,2}):(\d{2}))?/);
    if (m) { y = m[1]; mo = m[2]; d = m[3]; h = m[4]; mi = m[5]; }
    else {
      m = raw.match(/^(\d{1,2})[-\/.](\d{1,2})[-\/.](\d{4})(?:[ T]+(\d{1,2}):(\d{2}))?/);
      if (m) { d = m[1]; mo = m[2]; y = m[3]; h = m[4]; mi = m[5]; }
    }
    if (!m) return NaN;
    var iso = y + '-' + pad(mo) + '-' + pad(d) + 'T' + (h !== undefined ? pad(h) : '23') + ':' + (mi !== undefined ? mi : '59') + ':00' + (tz || '+03:00');
    return new Date(iso).getTime();
  }

  if (!customElements.get('cnct-countdown')) {
    customElements.define('cnct-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = parseEnd(this.dataset.end, this.dataset.tz);
        this.els = { d: this.querySelector('[data-d]'), h: this.querySelector('[data-h]'), m: this.querySelector('[data-m]'), s: this.querySelector('[data-s]') };
        this.msg = this.querySelector('[data-msg]');
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      showMsg(text) {
        if (this.hasAttribute('data-design')) {
          this.hidden = false;
          this.classList.add('is-msg');
          this.msg.textContent = text;
          this.msg.hidden = false;
        } else {
          this.hidden = true;
        }
      }
      tick() {
        if (isNaN(this.end)) { this.showMsg('Date not recognised — use 2026-10-05 22:00'); clearInterval(this.timer); return; }
        var diff = this.end - Date.now();
        if (diff <= 0) { this.showMsg('This date has passed — countdown is hidden for customers'); clearInterval(this.timer); return; }
        this.hidden = false;
        var s = Math.floor(diff / 1000);
        this.els.d.textContent = pad(Math.floor(s / 86400));
        this.els.h.textContent = pad(Math.floor((s % 86400) / 3600));
        this.els.m.textContent = pad(Math.floor((s % 3600) / 60));
        this.els.s.textContent = pad(s % 60);
      }
    });
  }

  if (!customElements.get('cnct-low-stock')) {
    customElements.define('cnct-low-stock', class extends HTMLElement {
      connectedCallback() {
        try { this.stock = JSON.parse(this.querySelector('[data-stock]').textContent); } catch (e) { this.stock = {}; }
        this.threshold = parseInt(this.dataset.threshold, 10) || 5;
        this.text = this.querySelector('[data-low-text]');
        this.scope = this.closest('.product-information') || this.closest('section') || document;
        this.onVariant = (e) => {
          var r = e.detail && e.detail.resource;
          if (r && r.id) this.show(r.id); else setTimeout(() => this.read(), 150);
        };
        this.onChange = (e) => {
          if (e.target && e.target.closest && e.target.closest('variant-picker, .variant-picker, fieldset')) setTimeout(() => this.read(), 200);
        };
        document.addEventListener('variant:update', this.onVariant);
        this.scope.addEventListener('change', this.onChange);
        this.read();
      }
      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariant);
        if (this.scope) this.scope.removeEventListener('change', this.onChange);
      }
      read() {
        var input = this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
        var urlId = new URLSearchParams(window.location.search).get('variant');
        this.show(urlId || (input && input.value) || this.dataset.initial);
      }
      show(id) {
        var v = this.stock[String(id)];
        if (v && v.q !== null && v.q > 0 && v.q <= this.threshold) {
          var size = v.t && v.t !== 'Default Title' ? ' in ' + v.t : '';
          this.text.textContent = (v.q === 1 ? 'Last one left' : 'Only ' + v.q + ' left') + size;
          this.hidden = false;
        } else {
          this.hidden = true;
        }
      }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
